import { render, staticRenderFns } from "./formXPItem.vue?vue&type=template&id=492422c3"
import script from "./formXPItem.vue?vue&type=script&lang=js"
export * from "./formXPItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports